import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { convertYouTubeIdToImg } from 'appSrc/utils';
import { Link } from 'react-router-dom';
import AspectRatio from 'react-aspect-ratio';
import { convertToStandard } from 'appSrc/utils/list-article';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/NewPlayIcon';
import { PrimaryButton } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import ProductCarousel from './SideCarousel';
import style from './styles/style.module.css';

import defaultListCoverImage from 'appSrc/assets/img/list/default_list_image.png';


class ProductFocusedLAStackCard extends PureComponent {
    constructor(props) {
        super( props );

        this.state = {
            videoPlaying: false,
        };
    }
    renderCoverImage = ( item ) => {
        const youtubeImg = item.video_id && convertYouTubeIdToImg( item.video_id );
        const coverImage = item.cover_image || youtubeImg || defaultListCoverImage;

        return (
            <div className={ style.imageWrapper }>
                <img src={ coverImage } />
            </div>
        );
    }
    convertHTMLString = ( input ) => {
        var output = input.replace( /<[^>]*>/gm, '' );
        return output;
    }



    render() {
        const item = convertToStandard( this.props.item );
        const author = item.author || {};
        const profession = ( author.profession || {} ).title;

        var description = this.convertHTMLString( item.text );

        const movieMetaData = {
            attached_to: `${ item.type }_cover_video`,
            attached_id: item.id,
            video_author_id: item.userid,
        };

        var topCategory = item.categories.find( ( cat ) => ( cat.parent_id == null ) );
        if( !topCategory ) {
            topCategory = item.categories[0] || null;
        }

        if( this.props.screenType !== 'desktop' ) {
            return (
                <div className={ `${ style.productFocusedStackCard } ${ this.props.className }`.trim() }>
                    <div className={ style.visual }>
                        <AspectRatio ratio='16/7' className={ style.videoWrapper }>
                            <Link to={ item.internal_link }>
                                { this.renderCoverImage( item ) }
                            </Link>
                            <div className={ style.overlayInfo }>
                                { item.video_id &&
                                    <TheaterPlayIcon className={ style.playButton } youtubeId={ item.video_id }
                                    metaData={ movieMetaData } />
                                }
                            </div>
                        </AspectRatio>
                        <div className={ style.carousel }>
                            <ProductCarousel products={ item.desires } />
                        </div>
                    </div>
                    <div className={ style.info }>
                        <Link to={ item.internal_link } className={ style.listLink }>
                            <TextTruncate
                            text={ topCategory && topCategory.name }
                            title={ topCategory && topCategory.name } line={ 1 }
                            containerClassName={ style.category } />
                            <TextTruncate
                            text={ item.title }
                            title={ item.title } line={ 2 }
                            containerClassName={ style.name } />
                            <TextTruncate
                            text={ author.displayName }
                            title={ author.displayName } line={ 1 }
                            containerClassName={ style.userName } />
                            <TextTruncate
                            text={ profession }
                            title={ profession } line={ 1 }
                            containerClassName={ style.profession } />
                            <TextTruncate
                            text={ description }
                            title={ description } line={ 4 }
                            containerClassName={ style.description } />
                        </Link>
                        <Link to={ item.internal_link } className={ style.buttonLink }>
                            <PrimaryButton label={ `view ${ item.type }`.toUpperCase() } />
                        </Link>
                    </div>
                </div>
            );
        }

        return (
            <div className={ `${ style.productFocusedStackCard } ${ this.props.className }`.trim() }>
                <div className={ style.info }>
                    <Link to={ item.internal_link } className={ style.listLink }>
                        <TextTruncate
                        text={ topCategory && topCategory.name }
                        title={ topCategory && topCategory.name } line={ 1 }
                        containerClassName={ style.category } />
                        <TextTruncate
                        text={ item.title }
                        title={ item.title } line={ 2 }
                        containerClassName={ style.name } />
                        <TextTruncate
                        text={ author.displayName }
                        title={ author.displayName } line={ 1 }
                        containerClassName={ style.userName } />
                        <TextTruncate
                        text={ profession }
                        title={ profession } line={ 1 }
                        containerClassName={ style.profession } />
                        <TextTruncate
                        text={ description }
                        title={ description } line={ 5 }
                        containerClassName={ style.description } />
                    </Link>
                    <Link to={ item.internal_link } className={ style.buttonLink }>
                        <PrimaryButton label={ `view ${ item.type }`.toUpperCase() } />
                    </Link>
                </div>

                <Link to={ item.internal_link } className={ style.gap }></Link>

                <div className={ style.visual }>
                    <AspectRatio ratio='16/7' className={ style.videoWrapper }>
                        <Link to={ item.internal_link }>
                            { this.renderCoverImage( item ) }
                        </Link>
                        <div className={ style.overlayInfo }>
                            { item.video_id &&
                                <TheaterPlayIcon className={ style.playButton } youtubeId={ item.video_id }
                                metaData={ movieMetaData } />
                            }
                        </div>
                    </AspectRatio>
                    <div className={ style.carousel }>
                        <ProductCarousel products={ item.desires } />
                    </div>
                </div>
            </div>
        );
    }
}
ProductFocusedLAStackCard.propTypes = {
    item: PropTypes.object.isRequired,
};
ProductFocusedLAStackCard.defaultProps = {
    className: '',
};

const mapStateToProps = ( state ) => {
    return {
        screenType: state.screenSize.type,
    };
};

export default connect( mapStateToProps )( ProductFocusedLAStackCard );
